import { useQuery } from "react-query";
import { getAdminDashboard } from "../api/adminDashboard";
import { useUserSession } from "../context/UserContext";

export const useAdminDashboard = (periodDays = 30) => {
  const { userSession } = useUserSession();
  const token = userSession?.token.accessToken;

  return useQuery(
    ["adminDashboard", periodDays],
    () => getAdminDashboard(token!, periodDays),
    {
      enabled: Boolean(token && userSession?.user.isAdmin),
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  );
};
